import { router } from '@inertiajs/react';
import { Search } from 'lucide-react';
import { useRef, useState } from 'react';
import { Input } from '@/components/ui/input';

interface CredentialsSearchProps {
  eventSlug: string;
  search: string;
}

export function CredentialsSearch({
  eventSlug,
  search,
}: CredentialsSearchProps) {
  const [value, setValue] = useState(search);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  function handleChange(newValue: string) {
    setValue(newValue);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      router.get(
        `/admin/${eventSlug}/credentials`,
        newValue.trim() ? { q: newValue.trim() } : {},
        { replace: true, preserveState: true, preserveScroll: true },
      );
    }, 300);
  }

  return (
    <div className="relative">
      <Search className="-translate-y-1/2 absolute top-1/2 left-3 h-4 w-4 text-muted-foreground" />
      <Input
        placeholder="Search by card slug, label, or person..."
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        className="pl-10"
      />
    </div>
  );
}
